var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ai-call-attribute-picker" }, [
    _c(
      "div",
      { staticClass: "filter-menu" },
      [
        _vm.selectedMenu.length
          ? _c(
              "SupsisButton",
              { attrs: { ghost: "", small: "" }, on: { click: _vm.prev } },
              [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v(" chevron_left "),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.selectedMenu, function (menu) {
          return _c("div", { key: menu, staticClass: "breadcrumb-item" }, [
            _c("span", [
              _vm._v(
                " " + _vm._s(_vm.findAttributeByValue(menu).label) + " ✦ "
              ),
            ]),
          ])
        }),
      ],
      2
    ),
    _vm._v(" "),
    !_vm.selectedMenu.length
      ? _c(
          "div",
          { staticClass: "webhook-blocks" },
          _vm._l(_vm.aiCallBlocks, function (block) {
            return _c(
              "div",
              {
                key: block.id,
                staticClass: "block-item",
                on: {
                  click: function ($event) {
                    return _vm.selectBlock(block)
                  },
                },
              },
              [
                _c("span", { staticClass: "material-icons voice-agent-icon" }, [
                  _vm._v("record_voice_over"),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "name" }, [
                  _vm._v(_vm._s(block.name || "AI Call")),
                ]),
              ]
            )
          }),
          0
        )
      : _c("div", { staticClass: "attribute-list" }, [
          _c(
            "div",
            { staticClass: "attr-select" },
            _vm._l(_vm.filterAttributes(), function (attr) {
              return _c(
                "div",
                {
                  key: attr.value,
                  staticClass: "picker-item",
                  on: {
                    click: function () {
                      return _vm.select(attr.value)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "name" }, [
                    _vm._v(_vm._s(attr.label)),
                  ]),
                  _vm._v(" "),
                  attr.description
                    ? _c("span", { staticClass: "description" }, [
                        _vm._v(_vm._s(attr.description)),
                      ])
                    : _vm._e(),
                ]
              )
            }),
            0
          ),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }